import React, { useState, useEffect } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Checkbox from '@material-ui/core/Checkbox'
import style from './TagsBlock.module.css'

const TagsBlock = ({ tags, handleDeleteTags, setAllTags, unsetAllTags }) => {
  const [checked, setChecked] = useState(false)

  const WhiteBackgroundCheckbox = withStyles((theme) => ({
    root: {
      color: 'white',
      '& .MuiIconButton-label': {
        position: 'relative',
        zIndex: 0,
      },
      '&:not($checked) .MuiIconButton-label:after': {
        content: '""',
        left: 4,
        top: 4,
        height: 15,
        width: 15,
        position: 'absolute',
        backgroundColor: '#FC2A3A',
        zIndex: -1,
      },
    },
    checked: {},
  }))(Checkbox)

  const handleChange = (event) => {
    setChecked(event.target.checked)
  }

  useEffect(() => {
    if (checked) {
      setAllTags()
    } else {
      unsetAllTags()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked])

  const renderTagsButtons = tags.map((el) => (
    <button
      type="button"
      className={style.tag}
      key={el}
      name={el}
      onClick={(el) => handleDeleteTags(el)}
    >
      <span className={style.tagText}>{el}</span>
      <span className={style.iconClose}>X</span>
    </button>
  ))

  return (
    <div className={style.wrapper}>
      {/* <WhiteBackgroundCheckbox
        checked={checked}
        // style={{ backgroundColor: 'red' }}
        // color="default"
        inputProps={{ 'aria-label': 'checkbox with default color' }}
        onChange={handleChange}
      />
      <p className={style.checkboxText}>Select / Deselect All</p> */}
      <div className={style.checkButtons}>{renderTagsButtons}</div>
    </div>
  )
}

export default TagsBlock
